// dependencies
import { format, parseISO } from "date-fns";
import React from "react";

// components
import Chip from "../../../../../../components/Chip";
import { Grid } from "../../../../../../components/Grid";
import Link from "../../../../../../components/Link";
import Typography from "../../../../../../components/Text";
import TruncatedText from "../../../../../../components/Text/TruncatedText";

// types
import type { ReviewCycle } from "../../../../../../api/services/searchServiceResultTypes/reviewCycles";

//css
import css from "../ReviewCycles.module.scss";

const getReviewCycleTableCols = () => {
	return [
		{
			id: "name",
			label: "Name",
			isSortable: true,
			width: 442,
			getter: (reviewCycle: ReviewCycle) => {
				const { name, _id } = reviewCycle;

				return (
					<div className={css.row}>
						<Link href={`/review-cycle/${_id}/`}>
							<TruncatedText
								maxWidth={442}
								size="paragraph-3"
								color="primary-5"
								weight="regular"
								text={name}
							/>
						</Link>
					</div>
				);
			},
		},
		{
			id: "review_cycle_status_chips",
			label: "",
			isSortable: false,
			width: 238,
			getter: (reviewCycle: ReviewCycle) => {
				const easyAdd = reviewCycle["360_count"];
				const automationStatus = reviewCycle.automation_status;
				return (
					<Grid cols={1} gap={1} className={css.reviewCycleStatusChipsGrid}>
						{["active", "scheduled"].includes(automationStatus ?? "") && (
							<Chip color="green" label="Automated" className={css.statusChip} />
						)}
						{easyAdd > 0 && <Chip color="blue" label="360 Enabled" className={css.statusChip} />}
					</Grid>
				);
			},
		},
		{
			id: "start_date",
			label: "Start Date",
			isSortable: true,
			width: 159,
			getter: (reviewCycle: ReviewCycle) => {
				const { start_date } = reviewCycle;

				const parsedDate = parseISO(start_date);

				return (
					<Typography size="paragraph-3" weight="regular">
						{format(parsedDate, "MMM dd, yyyy h:mm a")}
					</Typography>
				);
			},
		},
		{
			id: "status",
			label: "Status",
			isSortable: true,
			width: 200,
			getter: (reviewCycle: ReviewCycle) => {
				const { status, reviews, completed_reviews } = reviewCycle;

				const statusText = `${status} (${completed_reviews?.length}/${reviews?.length || 0})`;

				return <TruncatedText maxWidth={185} size="paragraph-3" weight="regular" text={statusText} />;
			},
		},
	];
};

export default getReviewCycleTableCols;
